import {
  loadablePage as loadable,
  withDefaultLoaderModifiers,
} from "@gamedev-web/gamedev-sdk-core";

export const FaqPage = loadable(() => withDefaultLoaderModifiers(import("./FaqPage")));
